import {
    GET_VERSION_LIST,
    SAVE_VERSION_LIST,
  
    SAVE_VERSION,
    SAVE_VERSION_SUCCESS,
  
    UPDATE_VERSION,
    UPDATE_VERSION_SUCCESS,
  
    DELETE_VERSION,
    DELETE_VERSION_SUCCESS,
  
    GET_VERSION_STATUS_UPDATE_REQUEST,
    UPDATE_VERSION_STATUS_SUCCESS,
  } from "../types/action-type";
  
  /* ---------- GET LIST ---------- */
  export const getVersionList = () => ({
    type: GET_VERSION_LIST,
  });
  
  /* ---------- SAVE LIST ---------- */
  export const saveVersionList = (data) => ({
    type: SAVE_VERSION_LIST,
    data,
  });
  
  /* ---------- ADD VERSION ---------- */
  export const saveVersion = (data) => ({
    type: SAVE_VERSION,
    data,
  });
  
  export const saveVersionSuccess = () => ({
    type: SAVE_VERSION_SUCCESS,
  });
  
  /* ---------- UPDATE VERSION ---------- */
  export const updateVersion = (data) => ({
    type: UPDATE_VERSION,
    data,
  });
  
  export const updateVersionSuccess = () => ({
    type: UPDATE_VERSION_SUCCESS,
  });
  
  /* ---------- UPDATE STATUS ---------- */
  export const getVersionStatusUpdateRequest = (data) => ({
    type: GET_VERSION_STATUS_UPDATE_REQUEST,
    data,
  });
  
  export const updateVersionStatusSuccess = () => ({
    type: UPDATE_VERSION_STATUS_SUCCESS,
  });
  
  /* ---------- DELETE VERSION ---------- */
  export const deleteVersion = (id) => ({
    type: DELETE_VERSION,
    payload: id, // ✅ clear naming
  });
  
  export const deleteVersionSuccess = () => ({
    type: DELETE_VERSION_SUCCESS,
  });
  